<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="商品名称" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.goods_id"
                placeholder="选择商品"
                allowClear
                 @change="goodsChange"
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in goodsOptions"
                  :value="option.id"
                >{{option.title}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="商品规格">
              <a-select
                showSearch
                optionFilterProp="children"
                v-model="queryParam.sku_id"
                placeholder="选择SKU规格"
                allowClear 
              >
                <a-select-option
                  :key="option.id"
                  v-for="option in skuOptions"
                  :value="option.id"
                >{{option.sku_format}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          
          <a-col :md="8" :sm="24">
            <a-form-item label="日期区间">
              <a-range-picker
                v-model="time_range_moment"
                style="width: 100%"
                format="YYYY-MM-DD HH:mm:ss"
                :showTime="{
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="变动类型">
               <a-select v-model="queryParam.type" placeholder="请选择" allowClear>
                <a-select-option value="order">订单下单</a-select-option>
                <a-select-option value="sale_order">销售单下单</a-select-option>
                <a-select-option value="purchase">商品采购</a-select-option>
                <a-select-option value="inventory">商品盘点</a-select-option> 
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number
                  v-model="queryParam.callNo"
                  style="width: 100%"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker
                  v-model="queryParam.date"
                  style="width: 100%"
                  placeholder="请输入更新日期"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select
                  v-model="queryParam.useStatus"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? "收起" : "展开" }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download()" style="margin-left: 8px">
        库存变动表下载
        <a-icon type="download" />
      </a-button>
    </div>

    <div class="diy-table">
    <s-table
      ref="table"
      size="default"
      :columns="columns" 
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="title1" slot-scope="title, record">
        <img
          :src="record.pic_url"
          style="width: 40px; vertical-align: middle"
        />
        {{ record.title }}
        <br/>
        规格：
        {{ record.sku_name
        }}
      </span>
      <p slot="change1" slot-scope="title, record">
         
        {{ record.new_stock-record.change }} <span v-if="record.change>=0">+</span> {{record.change}} = {{record.new_stock}}
      </p>
      <p slot="price1" slot-scope="title, record">
         
        {{ record.unit_price }} 
        <br/>

        {{ record.price }} 
      </p>

      <span slot="caozuoren" slot-scope="title, record">
         {{record.change_types}}
       ( {{ record.operate_user_name }})
        <br/>
        {{ record.create_time_str }}
      </span>

      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleLogManage(record)">详情</a>
          <!-- <a-divider type="vertical" /> -->
        </template>
      </span>
    </s-table>
    </div>

    <a-modal
      :maskClosable="false"
      title="详情"
      :width="1000"
      style="top: 20px"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="visible = false"
    >
      <a-spin :spinning="saveLoading">
        <!-- <a-form :form="form"> -->
        <a-card style="" v-if="detail.change_type == 'order'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">订单下单</detail-list-item>
            <detail-list-item term="订单编号">{{detail.code}}</detail-list-item>
            <detail-list-item term="购买人">{{detail.buyer_user_name}}</detail-list-item>
            <detail-list-item term="收件人">{{detail.name}}</detail-list-item>
            <detail-list-item term="手机号">{{detail.phone}}</detail-list-item>
            <detail-list-item term="地址">{{detail.province}}{{detail.city}}{{detail.county}}{{detail.address}}</detail-list-item>
            <detail-list-item term="订单状态">{{detail.status_data.name}}</detail-list-item>
          </detail-list>
        </a-card>
        <a-card style="" v-if="detail.change_type == 'order_close'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">订单关闭</detail-list-item>
            <detail-list-item term="订单编号">{{detail.code}}</detail-list-item>
            <detail-list-item term="购买人">{{detail.buyer_user_name}}</detail-list-item>
            <detail-list-item term="收件人">{{detail.name}}</detail-list-item>
            <detail-list-item term="手机号">{{detail.phone}}</detail-list-item>
            <detail-list-item term="地址">{{detail.province}}{{detail.city}}{{detail.county}}{{detail.address}}</detail-list-item>
            <detail-list-item term="订单状态">{{detail.status_data.name}}</detail-list-item>
          </detail-list>
        </a-card>
        <a-card style="" v-if="detail.change_type == 'order_refund'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">订单退货</detail-list-item>
            <detail-list-item term="订单编号">{{detail.code}}</detail-list-item>
            <detail-list-item term="购买人">{{detail.buyer_user_name}}</detail-list-item>
            <detail-list-item term="收件人">{{detail.name}}</detail-list-item>
            <detail-list-item term="手机号">{{detail.phone}}</detail-list-item>
            <detail-list-item term="地址">{{detail.province}}{{detail.city}}{{detail.county}}{{detail.address}}</detail-list-item>
            <detail-list-item term="订单状态">{{detail.status_data.name}}</detail-list-item>
          </detail-list>
        </a-card>
        <a-card style="" v-if="detail.change_type == 'sale' || detail.change_type == 'sale_order'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">销售单下单</detail-list-item>
            <detail-list-item term="销售单名称">{{detail.sale_title}}</detail-list-item>
            <detail-list-item term=""></detail-list-item>
            <detail-list-item term="订单编号">{{detail.code}}</detail-list-item>
            <detail-list-item term="购买人">{{detail.buyer_user_name}}</detail-list-item>
            <detail-list-item term="收件人">{{detail.name}}</detail-list-item>
            <detail-list-item term="手机号">{{detail.phone}}</detail-list-item>
            <detail-list-item term="地址">{{detail.province}}{{detail.city}}{{detail.county}}{{detail.address}}</detail-list-item>
            <detail-list-item term="订单状态">{{detail.status_data.name}}</detail-list-item>
          </detail-list>
        </a-card>

        <a-card style="" v-if="detail.change_type == 'purchase'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">采购</detail-list-item>
            <detail-list-item term="采购单名称">{{detail.sale_title}}</detail-list-item>
            <detail-list-item term="采购时间">{{detail.purchase_time_str}}</detail-list-item>
            <detail-list-item term="采购单流水号">{{detail.purchase_code}}</detail-list-item>
            <detail-list-item term="采购人">{{detail.purchase_user_name}}</detail-list-item>
          </detail-list>
        </a-card>
        <a-card style="" v-if="detail.change_type == 'inventory'" :bordered="true">
          <detail-list title="" :col="2">
            <detail-list-item term="商品">{{detail.goods_title}}</detail-list-item>
            <detail-list-item term="规格">{{detail.sku_name}}</detail-list-item>
            <detail-list-item term="变化">{{detail.change}}</detail-list-item>
            <detail-list-item term="单价">{{detail.unit_price}}</detail-list-item>
            <detail-list-item term="金额">{{detail.price}}</detail-list-item>
            <detail-list-item term="来源">盘点</detail-list-item>
            <detail-list-item term="盘点单名称">{{detail.inventory_name}}</detail-list-item>
            <detail-list-item term="盘点时间">{{detail.check_create_time_str}}</detail-list-item>
            <detail-list-item term="盘点单流水号">{{detail.inventory_code}}</detail-list-item>
            <detail-list-item term="盘点人">{{detail.inventory_user_name}}</detail-list-item>
          </detail-list>
        </a-card>
        <!-- </a-form> -->
      </a-spin>
    </a-modal>
  </a-card>
</template>

<style scoped>
.diy-table>>>.ant-table-thead > tr > th, .diy-table>>>.ant-table-tbody > tr > td{
  padding: 0 !important
}
</style>
<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import moment from "moment";
import areaOptions from "@/utils/area";

import DetailList from "@/components/tools/DetailList";
const DetailListItem = DetailList.Item;
import PriceInput from "@/components/PriceInput/";

import RSwitch from "@/components/RSwitch/";
import { getStockChangeList,getGoodsSkuDetail, getStockChangeDetail,getStockDownloadUrl } from "@/api/purchase";

import PicUploader from "@/components/PicUploader/";
import {
  getGoodsOptions, 
} from '@/api/order' 
export default {
  name: "StockChangeList",
  components: {
    AInput,
    ATextarea,
    RSwitch,
    STable,
    PriceInput,
    PicUploader,
    DetailList,
    DetailListItem,
  },
  data() {
    return {
      areaOptions,
      time_range_moment: [],
      change_type: "",
      saveLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
      },
      groupOptions: [],
      formData: {
        can_apply_partner: 2,
        is_partner: 2,
        areas: [],
        weixin_pic: [],
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
          sorter: true,
        },
        {
          title: "商品名称/规格",
          width: "150px",
          dataIndex: "title",
          scopedSlots: { customRender: "title1" },
        }, 
        {
          title: "变动前/变动/变动后",
          width: "100px",
          dataIndex: "change_type",
          scopedSlots: { customRender: "change1" },
        }, 
        {
          title: "单价/金额",
          width: "60px",
          dataIndex: "unit_price",
          scopedSlots: { customRender: "price1" },
        }, 
        {
          title: "操作人",
          width: "80px",
          dataIndex: "operate_user_name",
          scopedSlots: { customRender: "caozuoren" },
        }, 
        {
          title: "操作",
          dataIndex: "action",
          width: "50px",
          scopedSlots: { customRender: "action" },
        },
      ],

      visible: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        this.queryParam.user_group_ids = [];
        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            this.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
        } else {
          this.queryParam.time_range = [];
        }
        this.queryParam = Object.assign(this.queryParam, parameter);
        return getStockChangeList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      detail: {
        change_type:''
      },
      goodsOptions:[],
      skuOptions:[]
    };
  },
  created() {
    //      getRoleList({ t: new Date()})
  },
  mounted() {
    let self = this;
    self.getGoodsOptions()

  },
  methods: {
    moment,
    goodsChange(goods_id) {
      console.log(goods_id); 
      if (!goods_id) {
        this.skuOptions=[];
      }
      let that = this;
      getGoodsSkuDetail({ goods_id: goods_id })
        .then((res) => {
          that.skuOptions = res.data.sku;
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },
    getGoodsOptions() {
      let self = this
      getGoodsOptions()
        .then(res => {
          self.goodsOptions = res.data
        })
        .catch(err => {
          self.$message.error(err.data.msg)
        })
    },
    handleLogManage(record) {
      let self = this;
      self.visible = true;
      self.change_type = record.change_type;
      getStockChangeDetail({ id: record.id, type: record.change_type }).then(
        (res) => {
          self.detail = res.data;
          console.log(res);
        }
      );
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },

    resetSearchForm() {
      this.queryParam = {
        date: moment(new Date()),
      };
    },
    download(type) {
      let that = this
      getStockDownloadUrl(Object.assign(this.queryParam, { type: type }))
        .then(res => {
          console.log(res)
          window.open(res.data)
        })
        .catch(err => {
          that.$message.error(err.data.msg)
        })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
};
</script>
